import { Box, Skeleton } from '@mui/material'
import { Colors } from '@sweatpals/react-ui-kit'

const HostPageLoader = () => (
  <Box sx={{mt: '40px', width: '100%', padding: '0 20px'}}>
    <Box sx={{display: 'flex', alignItems: 'flex-start', width: '100%', gap: '24px', mb: '24px', flexDirection: {xs: 'column', md: 'row'}}}>
      <Skeleton 
        variant='circular'
        animation='wave' 
        width={100} height={100} 
        sx={{
          boxSizing: 'border-box', 
          border: `1px solid ${Colors.white_a10}`, 
          backgroundColor: Colors.white_a10,
       }}
      />
      <Box>
        <Skeleton variant='rectangular' animation='wave' width={98} height={14} sx={{borderRadius: '12px', backgroundColor: Colors.white_a30, mb: '10px'}} />
        <Box sx={{display: 'flex', gap: '8px', mb: '16px', flexWrap: 'wrap'}}>
          <Skeleton variant='rectangular' animation='wave' width={112} height={8} sx={{borderRadius: '12px', backgroundColor: Colors.white_a30}} />
          <Skeleton variant='rectangular' animation='wave' width={112} height={8} sx={{borderRadius: '12px', backgroundColor: Colors.white_a30}} />
          <Skeleton variant='rectangular' animation='wave' width={112} height={8} sx={{borderRadius: '12px', backgroundColor: Colors.white_a30}} />
        </Box>
        <Skeleton variant='rectangular' animation='wave' width={168} height={46} sx={{borderRadius: '250px', backgroundColor: Colors.white_a10, mb: '20px'}} />
        <Box sx={{display: 'flex', gap: '8px', mb: '8px', flexWrap: 'wrap'}}>
          <Skeleton variant='rectangular' animation='wave' width={260} height={12} sx={{borderRadius: '12px', backgroundColor: Colors.white_a20}} />
          <Skeleton variant='rectangular' animation='wave' width={141} height={12} sx={{borderRadius: '12px', backgroundColor: Colors.white_a20}} />
          <Skeleton variant='rectangular' animation='wave' width={125} height={12} sx={{borderRadius: '12px', backgroundColor: Colors.white_a20}} />
          <Skeleton variant='rectangular' animation='wave' width={125} height={12} sx={{borderRadius: '12px', backgroundColor: Colors.white_a20}} />
        </Box>
        <Box sx={{display: 'flex', gap: '8px', mb: '8px', flexWrap: 'wrap'}}>
          <Skeleton variant='rectangular' animation='wave' width={314} height={12} sx={{borderRadius: '12px', backgroundColor: Colors.white_a8}} />
          <Skeleton variant='rectangular' animation='wave' width={239} height={12} sx={{borderRadius: '12px', backgroundColor: Colors.white_a10}} />
          <Skeleton variant='rectangular' animation='wave' width={125} height={12} sx={{borderRadius: '12px', backgroundColor: Colors.white_a10}} />
        </Box>
        <Box sx={{display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
          <Skeleton variant='rectangular' animation='wave' width={197} height={12} sx={{borderRadius: '12px', backgroundColor: Colors.white_a8}} />
          <Skeleton variant='rectangular' animation='wave' width={118} height={12} sx={{borderRadius: '12px', backgroundColor: Colors.white_a5}} />
          <Skeleton variant='rectangular' animation='wave' width={118} height={12} sx={{borderRadius: '12px', backgroundColor: Colors.white_a5}} />
        </Box>
      </Box>
    </Box>
    <Box 
      sx={{
        width: '100%', 
        mb: '41px', 
        height: '44px', 
        display: 'flex', 
        gap: '8px', 
        boxSizing: 'border-box', 
        overflowX: 'scroll',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        scrollbarWidth: 'none',
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '0',
          left: 0,
          width: '100%',
          zIndex: 1,
          height: '2px',
          backgroundColor: Colors.white_a10,
        }
      }}
    >
       <Box 
          sx={{
            width: '205px', 
            minWidth: '205px',
            height: '100%', 
            backgroundColor: Colors.white_a10, 
            borderRadius: '8px 8px 0 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            gap: '8px',
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: '-2px',
              left: 0,
              width: '100%',
              zIndex: 1,
              height: '2px',
              backgroundColor: Colors.white_a20,
            }
          }}
        >
          <Skeleton variant='circular' animation='wave' width={24} height={24} sx={{backgroundColor: Colors.white_a30}} />
          <Skeleton variant='rectangular' animation='wave' width={141} height={12} sx={{backgroundColor: Colors.white_a30, borderRadius: '12px'}} />
       </Box>
       <Box 
          sx={{
            width: '151px', 
            height: '100%', 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
          }}
        >
          <Skeleton variant='circular' animation='wave' width={24} height={24} sx={{backgroundColor: Colors.white_a30}} />
          <Skeleton variant='rectangular' animation='wave' width={87} height={12} sx={{backgroundColor: Colors.white_a30, borderRadius: '12px'}} />
       </Box>
       <Box 
          sx={{
            width: '151px', 
            height: '100%', 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
          }}
        >
          <Skeleton variant='circular' animation='wave' width={24} height={24} sx={{backgroundColor: Colors.white_a30}} />
          <Skeleton variant='rectangular' animation='wave' width={87} height={12} sx={{backgroundColor: Colors.white_a30, borderRadius: '12px'}} />
       </Box>
       <Box 
          sx={{
            width: '151px', 
            height: '100%', 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
          }}
        >
          <Skeleton variant='circular' animation='wave' width={24} height={24} sx={{backgroundColor: Colors.white_a30}} />
          <Skeleton variant='rectangular' animation='wave' width={87} height={12} sx={{backgroundColor: Colors.white_a30, borderRadius: '12px'}} />
       </Box>
       <Box 
          sx={{
            width: '151px', 
            height: '100%', 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
          }}
        >
          <Skeleton variant='circular' animation='wave' width={24} height={24} sx={{backgroundColor: Colors.white_a30}} />
          <Skeleton variant='rectangular' animation='wave' width={87} height={12} sx={{backgroundColor: Colors.white_a30, borderRadius: '12px'}} />
       </Box>
    </Box>
    <Box sx={{width: '100%', display: 'flex', gap: '27px', justifyContent: 'space-between'}}>
      <Box sx={{pl: '24px', position: 'relative', width: '100%'}}>
        <Box sx={{
          position: 'absolute', 
          top: '0', 
          left: '5px', 
          width: '2px', 
          height: '100%', 
          transform: 'translateY(12px)',
          backgroundColor: Colors.white_a5, 
          zIndex: 1
        }} />
        <Box sx={{
          position: 'absolute', 
          top: '2px',
          left: '2px', 
          width: '8px', 
          height: '8px',
          borderRadius: '50%',
          backgroundColor: Colors.white_a20, 
          zIndex: 3
        }} />
        <Box sx={{
          position: 'absolute', 
          top: '0',
          left: '0', 
          width: '12px', 
          height: '12px',
          borderRadius: '50%',
          backgroundColor: Colors.white_a10, 
          zIndex: 2
        }} />
        <Box sx={{
          position: 'absolute', 
          top: '422px',
          left: '2px', 
          width: '8px', 
          height: '8px',
          borderRadius: '50%',
          backgroundColor: Colors.white_a15, 
          zIndex: 3
        }} />
        <Box sx={{
          position: 'absolute', 
          top: '420px',
          left: '0', 
          width: '12px', 
          height: '12px',
          borderRadius: '50%',
          backgroundColor: Colors.white_a10, 
          zIndex: 2
        }} />
        <Box sx={{display: 'flex', gap: '8px', mb: '21px'}}>
          <Skeleton variant='rectangular' animation='wave' width={112} height={10} sx={{borderRadius: '12px', backgroundColor: Colors.white_a20}} />
          <Skeleton variant='rectangular' animation='wave' width={112} height={10} sx={{borderRadius: '12px', backgroundColor: Colors.white_a20}} />
        </Box>
        <Skeleton 
          variant='rectangular' 
          animation='wave' 
          width='100%' 
          height={175} 
          sx={{borderRadius: '8px', backgroundColor: Colors.white_a5, border: `1px solid ${Colors.white_a8}`, mb: '16px'}} 
        />
        <Skeleton 
          variant='rectangular' 
          animation='wave' 
          width='100%' 
          height={175} 
          sx={{borderRadius: '8px', backgroundColor: Colors.white_a5, border: `1px solid ${Colors.white_a8}`, mb: '24px'}} 
        />
        <Box sx={{display: 'flex', gap: '8px', mb: '21px'}}>
          <Skeleton variant='rectangular' animation='wave' width={112} height={10} sx={{borderRadius: '12px', backgroundColor: Colors.white_a8}} />
          <Skeleton variant='rectangular' animation='wave' width={112} height={10} sx={{borderRadius: '12px', backgroundColor: Colors.white_a8}} />
        </Box>
        <Skeleton 
          variant='rectangular' 
          animation='wave' 
          width='100%' 
          height={175} 
          sx={{borderRadius: '8px', backgroundColor: Colors.white_a5, border: `1px solid ${Colors.white_a5}`, mb: '24px'}} 
        />
      </Box>
      <Box sx={{ width: '318px', boxSizing: 'border-box', display: {xs: 'none', md: 'block'} }}>
        <Skeleton 
          variant='rectangular' 
          animation='wave' 
          width={318} 
          height={340} 
          sx={{borderRadius: '8px', backgroundColor: Colors.white_a5, mb: '14px', border: `1px solid ${Colors.white_a5}`}} 
        />
        <Skeleton 
          variant='rectangular' 
          animation='wave' 
          width={318} 
          height={340} 
          sx={{borderRadius: '8px', backgroundColor: Colors.white_a5, mb: '24px', border: `1px solid ${Colors.white_a5}`}} 
        />
        <Skeleton 
          variant='rectangular' 
          animation='wave' 
          width={168} 
          height={36} 
          sx={{borderRadius: '8px', backgroundColor: Colors.white_a5, margin: "0 auto"}} 
        />
      </Box>
    </Box>
  </Box>
)

export default HostPageLoader